var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { GraphQLNonEmptyString, GraphQLURL } from "graphql-scalars";
import { ArgsType, Field, InputType, ObjectType } from "type-graphql";
import { FilteredListQueryArgs } from "../filtering/FilteredListQueryArgs.js";
import { ImageNode } from "../resources/Image.js";
import { AbstractGraphQLPaginatedResponse } from "./PaginatedResponse.js";
let CreateImageInput = class CreateImageInput {
    alt;
    url;
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], CreateImageInput.prototype, "alt", void 0);
__decorate([
    Field(() => GraphQLURL, { nullable: true }),
    __metadata("design:type", Object)
], CreateImageInput.prototype, "url", void 0);
CreateImageInput = __decorate([
    InputType()
], CreateImageInput);
export { CreateImageInput };
let ListImagesArgs = class ListImagesArgs extends FilteredListQueryArgs("ImageResolver", [
    "alt",
    "width",
    "height",
    "createdAt",
    "updatedAt",
]) {
};
ListImagesArgs = __decorate([
    ArgsType()
], ListImagesArgs);
export { ListImagesArgs };
let ListImagesResponse = class ListImagesResponse extends AbstractGraphQLPaginatedResponse {
    data;
};
__decorate([
    Field(() => [ImageNode], { nullable: false }),
    __metadata("design:type", Array)
], ListImagesResponse.prototype, "data", void 0);
ListImagesResponse = __decorate([
    ObjectType("ListImagesResponse", {
        implements: (AbstractGraphQLPaginatedResponse),
    })
], ListImagesResponse);
export { ListImagesResponse };
//# sourceMappingURL=GetImageByUuidResponse.js.map